import React, {useState} from "react";
import ValidateMessages from "../../../../../../core/models/static/texts/vallidate-messages";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import {Col, Row} from "reactstrap";
import Form from "../../../../base/form";
import Button from "../../../../base/button/button";
import {DialogActions, DialogContent, Divider} from "@mui/material";
import {OutlinedInputForm} from "../../../../base/input/outlined_input";
import Api from "../../../../../../core/services/api/api";
import {MuiRFF, Yup} from '../../../../form';

const schema = Yup.object().shape({
    periodDays: Yup.number().nullable().required(ValidateMessages.required).typeError(ValidateMessages.incorrectType('Number')),
    permittedCount: Yup.number().nullable().required(ValidateMessages.required).typeError(ValidateMessages.incorrectType('Number')),
});

const validate = MuiRFF.makeValidate(schema);
const required = MuiRFF.makeRequired(schema);

const ConfigureCustomerBypassLimitsSection = ({customer, submissionErrors, setSubmissionErrors, setOpen}) => {
    const [submitting, setSubmitting] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Configures the bypass limitations of the current customer with the given values.
     *
     * @param {any} values formValues
     * @return {Promise<void | undefined>}
     */
    const configureBypassLimit = async (values) => {
        const forApi = {
            customerId: customer?.id,
            periodDays: parseInt(values.periodDays),
            permittedTimes: parseInt(values.permittedCount),
        }
        setSubmitting(true);
        const response = await Api.saveQuoteBypassRuleForCustomer(forApi);
        if (!isMounted()) return;
        setSubmitting(false);
        if (response?.resultFlag) {
            setSubmissionErrors(null);
        }
        return Promise.resolve();
    }

    return (
        <>
            <DialogContent className={''}>
                <Col xs={12} className={'mb-4'}>
                    <p className={'text-sm font-weight-regular mt-2 mb-1'}>
                        There are <span className={'mx-1 font-weight-bold'}>
                        {submissionErrors?.permittedTimes ?? 0} ByPass
                    </span> records that have been founded for <span className={'mx-1 font-weight-bold'}>
                        {customer?.name ?? ""}
                    </span> in the <span className={'mx-1 font-weight-bold'}>
                        past {submissionErrors?.periodDays} days
                    </span>.
                        You can not submit a new one right now. You can also configure a new limitation for the
                        customer and try again.
                    </p>
                    {
                        !!submissionErrors?.submitterName &&
                        <p className={'text-sm font-weight-regular mb-2'}>
                            Latest record has been submitted
                            by <span className={'mx-1 font-weight-bold'}>
                             {(submissionErrors?.submitterName ?? '')}
                        </span>
                        </p>
                    }
                </Col>
                <Col xs={12} className={'mb-4'}>
                    <Form
                        id={'form'}
                        className='d-flex flex-wrap w-100 align-items-center'
                        onSubmit={configureBypassLimit}
                        validate={validate}
                        initialValues={{}}
                        render={({values, form}) => {
                            return (
                                <>
                                    <Col xs={12} className={'mb-3'}>
                                        <OutlinedInputForm
                                            label={'Period (days)'}
                                            name={'periodDays'}
                                            type={'number'}
                                            inputProps={{
                                                min: 0,
                                            }}
                                            required={!!required.periodDays}
                                            value={values?.periodDays ?? ''}
                                            onChange={(e) => form.change(e.target.name, !e.target.value ? undefined : parseInt(e.target.value) >= 0 ? parseInt(e.target.value) : '0')}
                                        />
                                    </Col>
                                    <Col xs={12} className={'mb-4'}>
                                        <OutlinedInputForm
                                            label={'Permitted count'}
                                            name={'permittedCount'}
                                            type={'number'}
                                            inputProps={{
                                                min: 0,
                                            }}
                                            required={!!required.permittedCount}
                                            value={values?.permittedCount ?? ''}
                                            onChange={(e) => form.change(e.target.name, !e.target.value ? undefined : parseInt(e.target.value) >= 0 ? parseInt(e.target.value) : '0')}
                                        />
                                    </Col>
                                </>
                            )
                        }}
                    />
                </Col>
            </DialogContent>
            <DialogActions className={'p-0'}>
                <Row className={'w-100 no-gutters'}>
                    <Divider className='divider'/>
                    <Row className='no-gutters justify-content-between align-items-start w-100'>
                        <Button
                            disabled={submitting}
                            variant={'dialog'}
                            color={'primary'}
                            onClick={() => setOpen(false)}
                            borderRadius={'0 8px 0 8px'}
                        >
                            Close
                        </Button>
                        <Button
                            disabled={submitting}
                            variant={'dialog'}
                            color={'primary'}
                            form={'form'}
                            type={'submit'}
                            borderRadius={'8px 0 8px 0'}
                        >
                            {
                                submitting
                                    ? "Submitting..."
                                    : "Submit"
                            }
                        </Button>
                    </Row>
                </Row>
            </DialogActions>
        </>
    )
}

export default ConfigureCustomerBypassLimitsSection;
